import React from 'react';
import Icon from '../../../components/AppIcon';

const getTierConfig = (score) => {
  if (score >= 800) return { tier: 'Diamond', color: '#60A5FA', priority: 'Priority Access', icon: 'Gem' };
  if (score >= 600) return { tier: 'Platinum', color: '#A78BFA', priority: 'High Priority', icon: 'Star' };
  if (score >= 400) return { tier: 'Gold', color: '#F59E0B', priority: 'Early Access', icon: 'Award' };
  if (score >= 200) return { tier: 'Silver', color: '#94A3B8', priority: 'Standard Access', icon: 'Shield' };
  return { tier: 'Bronze', color: '#CD7F32', priority: 'Building Score', icon: 'TrendingUp' };
};

const EligibilityIndicator = ({ score = 0 }) => {
  const config = getTierConfig(score);
  const maxScore = 1000;
  const progress = Math.min((score / maxScore) * 100, 100);

  return (
    <div
      className="rounded-2xl p-6"
      style={{ background: 'rgba(30, 41, 59, 0.8)', border: '1px solid rgba(51, 65, 85, 0.8)' }}
    >
      <div className="flex items-start justify-between gap-4 mb-5">
        <div>
          <h2 className="text-xl font-semibold text-foreground">Your Eligibility</h2>
          <p className="text-muted-foreground text-sm mt-1">
            Creators with higher SocialCents Scores may receive priority access to the SocialCents Card.
          </p>
        </div>
        <div
          className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center"
          style={{ background: `${config?.color}15`, border: `1px solid ${config?.color}30` }}
        >
          <Icon name={config?.icon} size={20} style={{ color: config?.color }} />
        </div>
      </div>
      <div className="flex items-end gap-6 mb-5">
        <div>
          <p className="text-xs text-muted-foreground uppercase tracking-wider mb-1">SocialCents Score</p>
          <p
            className="text-4xl font-bold"
            style={{ color: config?.color, fontFamily: 'JetBrains Mono, monospace' }}
          >
            {score}
          </p>
        </div>
        <div className="mb-1">
          <span
            className="px-3 py-1 rounded-full text-xs font-semibold"
            style={{ background: `${config?.color}20`, color: config?.color, border: `1px solid ${config?.color}30` }}
          >
            {config?.tier}
          </span>
        </div>
      </div>
      {/* Progress bar */}
      <div className="space-y-2">
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>Score Progress</span>
          <span>{score} / {maxScore}</span>
        </div>
        <div className="h-2 rounded-full overflow-hidden" style={{ background: 'rgba(51, 65, 85, 0.8)' }}>
          <div
            className="h-full rounded-full transition-all duration-700"
            style={{
              width: `${progress}%`,
              background: `linear-gradient(90deg, ${config?.color}, ${config?.color}99)`
            }}
          />
        </div>
      </div>
      <div
        className="mt-4 flex items-center gap-2 px-4 py-3 rounded-xl text-sm"
        style={{ background: `${config?.color}08`, border: `1px solid ${config?.color}20` }}
      >
        <Icon name="Info" size={14} style={{ color: config?.color }} className="flex-shrink-0" />
        <span className="text-muted-foreground">
          Your current tier grants <span style={{ color: config?.color }} className="font-medium">{config?.priority}</span> to the SocialCents Card.
        </span>
      </div>
    </div>
  );
};

export default EligibilityIndicator;
